import { Component, OnInit } from '@angular/core';

import { NewsService } from '../services/newsService'
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css'],

})
export class ContentComponent implements OnInit {

  showtabnum = 'tab1';
  activeTab = true;
  showClass = true;

  newsPromotion: any[];
  constructor(private news: NewsService,public _Title: Title,private titleService: Title) { }
  ngOnInit() {
    this.titleService.setTitle('Pokpak');
    let newsPromotionTemp = this.news.getNewsShows() 
    newsPromotionTemp.subscribe((snap) => {
      this.newsPromotion = snap
      //console.log(this.newsPromotion)
    })
  }
  showContentActiveTab(tab: string) {
    this.showtabnum = tab;
    if (tab != 'tab1') {
      this.showClass = false;
    }
  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/content/content.component.ts